/*
 * Copyright 2022 Siemens
 */

import React from 'react';
import {Datastore} from '../common/datastore';
import {DatastoreItem, Datastores} from '../services/datastores';
import {Content} from '../common/content';

interface ExperimentState {
  isLoading: boolean;
  items: ReadonlyArray<DatastoreItem>;
}

export class Experiment extends React.Component<{}, ExperimentState> {
  readonly #symbol = Symbol('Experiment');

  constructor(props: {}, state: ExperimentState) {
    super(props, state);
    this.state = {isLoading: true, items: []};
  }

  override componentDidMount() {
    if (super.componentDidMount) super.componentDidMount();
    Datastores.experimentItems.addObserver(this.#symbol, (value) => {
      this.setState({isLoading: value === null, items: value === null ? [] : value});
    });
  }

  override componentWillUnmount() {
    Datastores.experimentItems.removeObserver(this.#symbol);
    if (super.componentWillUnmount) super.componentWillUnmount();
  }

  #reloadData(): void {
    this.setState({isLoading: true});
    Datastores.reloadDatastore();
  }

  override render() {
    return (
      <Content
        section='Datastore: Experiment'
        isLoading={this.state.isLoading}
      >
        <Datastore
          type='Experiment'
          items={this.state.items}
          reloadCommand={() => this.#reloadData()}
        />
      </Content>
    );
  }
}
